import { render, staticRenderFns } from "./QoutAllTable.vue?vue&type=template&id=0647f646&scoped=true"
import script from "./QoutAllTable.vue?vue&type=script&lang=ts"
export * from "./QoutAllTable.vue?vue&type=script&lang=ts"
import style0 from "./QoutAllTable.vue?vue&type=style&index=0&id=0647f646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0647f646",
  null
  
)

export default component.exports